import React, { Fragment, useEffect } from "react";
import HeadSection from "../components/company/HeadSection";
import MainSection from "../components/company/MainSection";
import Footer from "../components/footer/Footer";

export default function Company({ setTab }) {
  useEffect(() => setTab("Company"), [setTab]);
  return (
    <Fragment>
      <HeadSection />
      <MainSection />
      <Footer />
    </Fragment>
  );
}
